<template>
  <div class="flex w-full">
    <button class="prev" :disabled="disabled || firstValidSlide >= currentSlideIndex" @click="$emit('back')">
      <FontAwesomeIcon class="transform rotate-180" icon="play" />
    </button>
    <button class="next" :disabled="disabled || lastValidSlide <= currentSlideIndex" @click="$emit('next')">
      <FontAwesomeIcon icon="play" />
    </button>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  firstValidSlide: {
    type: Number,
    required: true,
  },
  lastValidSlide: {
    type: Number,
    required: true,
  },
  currentSlideIndex: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['back', 'next'])
</script>

<style lang="stylus" scoped>
button
  @apply flex-1 bg-gray-700 text-gray-100 p-2
  &:hover:not(:disabled)
    @apply bg-gray-600 text-white
  &:disabled
    @apply text-gray-600
</style>
